import makeStyles from "@material-ui/core/styles/makeStyles";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import ActionButton from "../../../components/common/ActionButton";
import ActionHeading from "../../../components/common/ActionHeading";
import Container from "../../../components/common/Container";
import HeaderBar from "../../../components/common/HeaderBar";
import PageHeading from "../../../components/common/PageHeading";
import RiskMeasureUpdateFilters from "../../../components/risk/RiskMeasureUpdateFilters";
import RiskMeasureUpdateListing from "../../../components/risk/RiskMeasureUpdateListing";
import { getLoggedInUser } from "../../../reducers";
import { clearIcon, workItemIcon } from "../../../util/icons";
import useLocationStateFilter from "../../../util/locationStateFilter";
import usePersistedState from "../../../util/persistedState";

const useStyles = makeStyles(() => ({
  root: {
    width: "100%",
  },
  contents: {
    marginBottom: "75px",
  },
}));

const defaultFilter = {
  ownerIds: [],
  riskRegisters: [],
  subTypes: [],
};

const MeasureUpdates = ({ history, loggedInUser }) => {
  const classes = useStyles();
  const [sortBy, setSortBy] = usePersistedState(
    `risk-measure-update-listing-sort-${loggedInUser.email}`,
    {
      field: "created",
      direction: "desc",
    }
  );
  const [filter, setFilter] = usePersistedState(
    `risk-measure-update-listing-filter-${loggedInUser.email}`,
    defaultFilter,
    ["textSearch"]
  );
  useLocationStateFilter(setFilter, history);

  const clearFilter = () => setFilter({ ...defaultFilter });

  const updateFilter = (key, value) => {
    setFilter({
      ...filter,
      [key]: value,
    });
  };

  return (
    <div className={classes.root}>
      <HeaderBar fluid>
        <ActionHeading
          heading={
            <PageHeading
              icon={workItemIcon("RISK_MEASURE_UPDATE")}
              heading="Risk measure updates"
            />
          }
          actions={[
            <ActionButton
              key="clearFilter"
              tooltip="Clear filters"
              icon={clearIcon()}
              onClick={clearFilter}
              data-cy="clear-filters-button"
            />,
          ]}
        />
      </HeaderBar>
      <RiskMeasureUpdateFilters filter={filter} updateFilter={updateFilter} />
      <Container fluid className={classes.contents}>
        <RiskMeasureUpdateListing
          history={history}
          filter={filter}
          clearFilter={clearFilter}
          sortBy={sortBy}
          updateSort={setSortBy}
        />
      </Container>
    </div>
  );
};

MeasureUpdates.propTypes = {
  history: PropTypes.object.isRequired,
  loggedInUser: PropTypes.object,
};

MeasureUpdates.defaultProps = {
  loggedInUser: null,
};

const mapStateToProps = (state) => ({
  loggedInUser: getLoggedInUser(state),
});

export default connect(mapStateToProps)(MeasureUpdates);
